import * as api from "../api/index";

export const UserService = {
  createAdminUser,
  updateAdminUser,
  changeAdminPassword,
  getAllAdminUserList,

  createParentUser,
  updateParnetUser,
  getAllParentList,
  getParentDetailsById,
  getAllParentListWithoutPagination,
  changeParentPassword,
  updateParnetAssignChannels,
  getParentChannelAndMaskList,

  createApiUser,
  getAllApiUserList,
  getAllApiUserListWithoutPagination,
  updateApiUser,
  changeApiPassword,
  updateApiUserMaskList,
  updateApiUserChannelList,
  getAssignMasks,
  getAssignChannels,

  resetPassword,
  getAllApproverList,
  getApproverListWithoutPagination,
  createApprover,
  updateApprover,
  changeApproverPassword,

  getSelfRegUsers,
  maskAsViewed,
};

async function createAdminUser(formData) {
  try {
    const { data } = await api.createAdminUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateAdminUser(formData) {
  try {
    const { data } = await api.updateAdminUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeAdminPassword(formData) {
  try {
    const { data } = await api.changeAdminPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllAdminUserList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllAdminUserList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createParentUser(formData) {
  try {
    const { data } = await api.createOwnerUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateParnetUser(formData) {
  try {
    const { data } = await api.updateOwnerUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllParentList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllOwnerList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getParentDetailsById(formData) {
  try {
    const { data } = await api.getParentDetailsById(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getParentChannelAndMaskList(formData) {
  try {
    const { data } = await api.getParentChannelAndMaskList(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllParentListWithoutPagination(formData) {
  try {
    const { data } = await api.getAllOwnerListWithoutPagination(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateParnetAssignChannels(formData) {
  try {
    const { data } = await api.updateParnetAssignChannels(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeParentPassword(formData) {
  try {
    const { data } = await api.changeOwnerPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createApiUser(formData) {
  try {
    const { data } = await api.createChildUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllApiUserListWithoutPagination(formData) {
  try {
    const { data } = await api.getAllApiUserListWithoutPagination(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllApiUserList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllChildUserList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateApiUser(formData) {
  try {
    const { data } = await api.updateChildUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeApiPassword(formData) {
  try {
    const { data } = await api.changeChildPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateApiUserMaskList(formData) {
  try {
    const { data } = await api.updateApiUserMaskList(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateApiUserChannelList(formData) {
  try {
    const { data } = await api.updateApiUserChannelList(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAssignMasks(formData) {
  try {
    const { data } = await api.getAssignMasks(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAssignChannels(formData) {
  try {
    const { data } = await api.getAssignChannels(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function resetPassword(formData) {
  try {
    const { data } = await api.resetPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllApproverList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllApproverList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createApprover(formData) {
  try {
    const { data } = await api.createApprover(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateApprover(formData) {
  try {
    const { data } = await api.updateApprover(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}


async function changeApproverPassword(formData) {
  try {
    const { data } = await api.changeApproverPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getApproverListWithoutPagination(formData) {
  try {
    const { data } = await api.getApproverListWithoutPagination(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getSelfRegUsers(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getSelfRegUsers(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function maskAsViewed(formData) {
  try {
    const { data } = await api.maskAsViewed(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
